import React, { useContext } from 'react';
import Avatar from "react-avatar";
import { VALIDATION_FIELD_MAPPING } from '../../../../utils/appConstant';
import ElipsisText from "../../../../components/ElipsisText";
import ElipsisCell from "../../../../components/TableBox/Cells/EllipsisCell";
import Link from "../../../../components/Link";
import { RowClassName, Modules, AuthRoutes, RouteParamsTypes } from "../../../../enums";
import { TableContext } from "../../../../contexts/TableContext";
import NoPropertyImg from '../../../../assets/img/custom/no-property.jpeg';

interface RowProps {
  item: any;
  className?: RowClassName;
}

const Row: React.FC<RowProps> = ({ item, className }) => {
  const { headCells } = useContext(TableContext);

  const handleViewClick = (id: string) => {
    window.open(`${Modules.resources}${AuthRoutes.properties}${RouteParamsTypes.view}/${id}`, '_blank');
  }

  return (
    <tr className={className}>
      {
        headCells.map((headCell) => {
          if (headCell.id === VALIDATION_FIELD_MAPPING.image) {
            return (
              <ElipsisCell
                key={headCell.id}
                width={headCell.width}
                node={<Avatar src={item.picture_url || NoPropertyImg} name={item.name} size="40" maxInitials={2} round />}
              />
            )
          }

          if (headCell.id === VALIDATION_FIELD_MAPPING.name) {
            return (
              <ElipsisCell
                key={headCell.id}
                width={headCell.width}
                node={
                  <ElipsisText
                    width="100%"
                    text={item.name || '-'}
                    node={<Link text={item.name || '-'}/>}
                    className="h6 mb-1 text-decoration-underline hyperlink"
                    onClick={() => handleViewClick(item.id)}
                  />
                }
              />
            )
          }

          if (headCell.id === VALIDATION_FIELD_MAPPING.managedBy) {
            return (
              <ElipsisCell
                key={headCell.id}
                width={headCell.width}
                text={item?.manager?.name ?? '-'}
              />
            )
          }

          if (headCell.id === VALIDATION_FIELD_MAPPING.city) {
            return (
              <ElipsisCell
                key={headCell.id}
                width={headCell.width}
                text={item?.city_data?.name ?? '-'}
              />
            )
          }

          return (<ElipsisCell key={headCell.id} width={headCell.width} text={item[headCell.id] || '-'} />);
        })
      }
    </tr>
  );
}

export default Row;
